let apiHost = "https://api.console.mrliuliang.com"; // 正式
// let apiHost = "https://api.console.dev.local:9082"; // 测试

let constants = {
    // host,
    apiHost,
};

export default constants;
